import { JDSNotificationButtonProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSNotificationButtonProps>
  ): React.FC<JDSNotificationButtonProps> =>
  (props: JDSNotificationButtonProps) => {
    return <Component {...{ ...props, _hasLabel: Boolean(props.label) }} />;
  };
